import GoDashboard from './go_dashboard';

export default GoDashboard;
